<template>
  <vx-card title="Action log">
    <ul class="vx-timeline">
      <li v-for="(actionLogEntry, idx) in venueCampaign.actionLog" :key="idx" class="cursor-pointer">
        <div class="timeline-icon" :class="`bg-${logItemColor(actionLogEntry)}`">
          <feather-icon :icon="logItemIcon(actionLogEntry)" svgClasses="text-white w-5 h-5" />
        </div>
        <div class="timeline-info">
          <p class="font-semibold">{{ actionLogEntry.title }}</p>
          <p class="whitespace-pre-wrap break-words">{{ actionLogEntry.comment }}</p>
        </div>
        <small class="text-grey activity-e-time"
          >{{ actionLogEntry.userAction.timestamp | formatDate }} by
          {{ actionLogEntry.userAction.userDisplayName }}</small
        >
      </li>
    </ul>
  </vx-card>
</template>

<script>
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  props: ["venueCampaign"],
  mixins: [campaignMixin],
  data() {
    return {
      moment,
    };
  },
  methods: {
    logItemColor(item) {
      return this.statusObject(item.status).color;
    },
    logItemIcon(item) {
      switch (item.status) {
        case "Approved":
          if (item.title == "Approved") return "CheckIcon";
          else return "ChevronRightIcon";
        case "Rejected":
          return "XIcon";
        default:
          return "ChevronRightIcon";
      }
    },
  },
};
</script>

<style lang="scss">
.bg-green {
  background-color: #4dbd74 !important;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>